import React from "react";
import ReactDOM from "react-dom";
import * as Sentry from "@sentry/react";
import authClient from "../../app/auth/Auth";
import MyAccountPage from "./components/MyAccountPage";
import { addContextLog } from "../../infrastructure/log";
import { setPageOnboarding } from "../../infrastructure/user-onboarding-client";

export function renderMyAccountPage() {
  ReactDOM.render(<MyAccountPage />, document.getElementById("page-container"));
}

export async function displayMyAccountPage() {
  renderMyAccountPage();
  const id = authClient.getEmployeeId();
  Sentry.configureScope((scope) => {
    scope.setUser({ id });
    scope.setExtra("companyId", `${id}`);
  });

  setPageOnboarding();
  addContextLog("info", "Set user to Sentry", "set user", { id });
}
